import { Col, Row } from "antd";
import React, { useState } from "react";
import { AssignDriverIcon, HandShakeIcon } from "../../common/CustomIcon";
import AssignDriver from "./AssignDriver";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import I18n from "../../common/I18n";
import AssignOrders from "../../components/orders/AssignOrders";
import TenderOrdersModal from "../../components/orders/tenders/TenderOrdersModal";

const UnassignedDriver = ({ loc, drivers, driverDetails, warehouse_id, currentOrder,
    refreshDetails, currentOrg, isCreditLimitExceed = false, isTender, organizationSettings}) => {

    const [assignDriver, setAssignDriver] = useState(false)
    const [requestAs, setRequestAs] = useState('driver')
    const [isAssignClicked, setIsAssignClicked] = useState(false);
    const [hoveredCol, setHoveredCol] = useState(null);
    const [showAgentTenderModal, setShowAgentTenderModal] = useState(false);

    const formatAddress = (consigneeDetails = {}) => {
        return ( {
            ...consigneeDetails,
            ...consigneeDetails.address,
        })
    }

    const assignmentOrderType = loc?.type_of_loc;
    const assignDriverTitle = `${loc?.label_name || assignmentOrderType || "Assign"} Driver`;
    const isImportedButNotCleared = currentOrder?.customer_order_details?.is_imported === true || currentOrder?.customer_order_details?.is_imported === "true";
    const useAgentLoadTender = organizationSettings?.agent_load_tender === "true";
    const tenderSelectedOrders = [{
      ...(currentOrder?.customer_order_details || {}),
      id: currentOrder?.customer_order_details?.id || currentOrder?.id,
      order_id: currentOrder?.customer_order_details?.id || currentOrder?.id,
    }];

    const handleTenderOrderClick = () => {
      if (useAgentLoadTender) {
        setShowAgentTenderModal(true);
        return;
      }
      setAssignDriver(true);
      setRequestAs("tender");
    };

    return (
        <div className="assign-driver" data-testid="assign-buttons">
            <Row
                type="flex"
                justify="space-around"
                align="middle"
            >   
               {currentOrder.type_of_order !== "LH" ? <Col
                   
                    // onClick={() => isCreditLimitExceed ?  
                    // renderNotification(I18n.t("order.account_limit_exceeded"), 'error')
                    // :  setIsAssignClicked(true)}
                >
                   
                   <AssignOrders
                          selectedOrders={[{
                            ...currentOrder.customer_order_details,
                            origin: formatAddress(_.find(currentOrder.locations, {type_of_loc: 'PICKUP'})) || null,
                            destination: formatAddress(_.find(currentOrder.locations, {type_of_loc: 'DELIVERY'})) || null,
                            weight: currentOrder?.customer_order_details?.weight,
                            weight_in_kgs: currentOrder?.customer_order_details?.weight_in_kgs,
                            related_order: currentOrder?.related_order_details?.related_order_id || '',

                          }]}
                          isAssignClicked={isAssignClicked}
                          setIsAssignClicked={setIsAssignClicked}
                          setIsHovered={setHoveredCol}
                          currentOrg={currentOrg}
                          organizationSettings={organizationSettings}
                          setOrderSelectedInfo={() => {}}
                          orderRefreshCall={() => {
                            refreshDetails()
                          }}
                          screenFrom="details"
                          assignmentOrderType={assignmentOrderType}
                          assignDriverTitle={assignDriverTitle}
                          disabled={isImportedButNotCleared}
                        />
                    
                </Col>
               :
                <Col
                    data-testid="assign-driver-button"
                    className="assign-driver-func"
                    style={isImportedButNotCleared ? {opacity: 0.5, pointerEvents: 'none'} : {}}
                    onClick={() => {
                      if (isImportedButNotCleared) return;
                        isCreditLimitExceed
                        ? renderNotification(I18n.t("order.account_limit_exceeded"), 'error')
                        : setAssignDriver(true);
                    }}
                    >
                    <AssignDriverIcon color='#576EC1' />
                    <span>Assign Driver</span>
                    
                </Col>}
                {isTender === true || useAgentLoadTender === true ? (
                <>
                  <Col className="or-text">or</Col>
                 <Col
                     data-testid="tender-order-button"
                     className="assign-driver-func"
                     onClick={handleTenderOrderClick}
                 >
                 <HandShakeIcon color="#576EC1" />
                 <span>Tender Order</span>
               </Col>
              </>
                ): null}
                
            </Row>
            {assignDriver &&
                <AssignDriver
                    assignDriver={assignDriver}
                    setAssignDriver={setAssignDriver}
                    drivers={drivers}
                    loc={loc}
                    warehouse_id={warehouse_id}
                    currentOrder={currentOrder}
                    driverDetails={driverDetails}
                    refreshDetails={refreshDetails}
                    currentOrg={currentOrg}
                    requestAs={requestAs}
                // driverDetails={driverDetails}
                />
            }
            {showAgentTenderModal && (
              <TenderOrdersModal
                visible={showAgentTenderModal}
                onClose={() => setShowAgentTenderModal(false)}
                selectedOrders={tenderSelectedOrders}
                preselectLegTypes={assignmentOrderType ? [assignmentOrderType] : null}
                onTendered={() => {
                  setShowAgentTenderModal(false);
                  if (refreshDetails) refreshDetails();
                }}
              />
            )}

        </div>
    )
}

export default UnassignedDriver
